import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { ModifierBQuestionnaireItem } from './questionnaire'

// Modifier B section questionnaire answer type mapping
export const MODIFIER_B_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [ModifierBQuestionnaireItem.MODIFIER_B_1_QUESTION]: QuestionnaireAnswerType.CODING,
  [ModifierBQuestionnaireItem.MODIFIER_B_1_NOTES]: QuestionnaireAnswerType.STRING,
  [ModifierBQuestionnaireItem.MODIFIER_B_2_QUESTION]: QuestionnaireAnswerType.CODING,
  [ModifierBQuestionnaireItem.MODIFIER_B_2_NOTES]: QuestionnaireAnswerType.STRING,
  [ModifierBQuestionnaireItem.MODIFIER_B_3_QUESTION]: QuestionnaireAnswerType.CODING,
  [ModifierBQuestionnaireItem.MODIFIER_B_3_NOTES]: QuestionnaireAnswerType.STRING,
  [ModifierBQuestionnaireItem.MODIFIER_B_4_QUESTION]: QuestionnaireAnswerType.CODING,
  [ModifierBQuestionnaireItem.MODIFIER_B_4_NOTES]: QuestionnaireAnswerType.STRING,
  [ModifierBQuestionnaireItem.MODIFIER_B_5_QUESTION]: QuestionnaireAnswerType.CODING,
  [ModifierBQuestionnaireItem.MODIFIER_B_5_NOTES]: QuestionnaireAnswerType.STRING,
  [ModifierBQuestionnaireItem.MODIFIER_B_6_QUESTION]: QuestionnaireAnswerType.CODING,
  [ModifierBQuestionnaireItem.MODIFIER_B_6_NOTES]: QuestionnaireAnswerType.STRING,
  [ModifierBQuestionnaireItem.MODIFIER_B_7_QUESTION]: QuestionnaireAnswerType.CODING,
  [ModifierBQuestionnaireItem.MODIFIER_B_7_NOTES]: QuestionnaireAnswerType.STRING
}
